'use strict';

angular.module('app.studies', [
    'commerce',
    'invitations',
    'route',
    'studies',
    'ui.router',
    'user',
]);
